export const SET_CPS_TESTS_DATA = "SET_CPS_TESTS_DATA";
export const SET_CPS_TESTS_RESULT_DATA = "SET_CPS_TESTS_RESULT_DATA";